<template>


  <div
      @click.stop
      class="popup-valid"
      v-if="modalIsOpen"
  >
    <div class="popup_validation">
      <div class="popup_validation_exit" @click.stop="closeModal">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L25 25M25 1L1 25" stroke="#4C4C4C" stroke-width="2.18368"/>
        </svg>
      </div>
      <div class="popup_validation_error">
        <svg class="popup_validation_error_svg" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="56" height="56">
            <rect width="56" height="56" fill="#C4C4C4"/>
          </mask>
          <g mask="url(#mask0)">
            <circle cx="28" cy="28" r="28" fill="#A50034"/>
            <path d="M30.1633 35.256H24.7873L23.7233 10.952H31.2833L30.1633 35.256ZM24.1153 38.672H30.8913V45H24.1153V38.672Z" fill="white"/>
          </g>
        </svg>

      </div>
      <div class="popup_validation_title">Ошибка!</div>
      <div class="popup_validation_subtitle">{{ text }}</div>
    </div>
  </div>
</template>

<script>
import {bus}  from "../../../utils/bus";

export default {
  name: "PopupValidation",
  data() {
    return {
      modalIsOpen: false,
      text: null
    }
  },
  methods: {
    closeModal() {
      this.modalIsOpen = false;
      if(document.querySelector('.overlay-body').classList.contains('active-modal')) {
        document.querySelector('.overlay-body').classList.remove('active-modal')
      }
    },
    openModal() {
      this.modalIsOpen = true;
      document.querySelector('.overlay-body').classList.add('active-modal')
    }
  },
  mounted() {
    bus.$on('close-modal-valid', () => {
      this.closeModal()
    });
    bus.$on('open-modal-valid', (text) => {
      this.text = text
      this.openModal()
    })
  }
}
</script>

<style lang="scss">
@import "popup-validation";
</style>